module.exports = __webpack_public_path__ + "static/img/project_target.4a7916bd.png";